import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: '',
  columns: [
    {
      id: 'user',
      label: 'USER',
    },
    {
      id: 'activity',
      label: 'ACTIVITY',
    },
  ],
}

export const stateData = [
  { user: 'Owen Chavez', activity: '$76440 added' },
  { user: 'Lucy Campbell', activity: '$36791 removed' },
  { user: 'Rosie Moss', activity: '$35284 added' },
  { user: 'Don Kim', activity: '$18722 added' },
  { user: 'Brent Herrera', activity: '$17084 removed' },
  { user: 'Lucinda Wise', activity: '$50002 added' },
]
